import { Box, HStack, Button, Image } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { convertToHashAnswers, getQuestionID } from "../../../utils/Helper";
import NewQuestionImage from "../../../assets/svgs/newQuestion.svg";
import { learningModes, questionTypes } from "../../../utils/LearningPathUtils";
import { AnswersLayout } from "./AnswerLayouts";
import "../../molecules/questionLayouts/QuestionLayout.css?__remix_sideEffect__";
import Assistant from "../ai-tutor/Assistant/Assistant";
import {
  handleRemoveExtraSpaceInBubbles,
  isEmptyArray } from
"../../../utils/common-utils";
import { isNotEmptyOrNull } from "../../../utils/common-utils";
import { handleCopyClick } from "../../../utils/TutorConstants";
import { useCustomToast } from "../../../components/molecules/ai-tutor/useCustomToast";
import CustomButton from "../../atoms/CustomButton/CustomButton";
import SubmitBtn from "../../../assets/submitIcon.svg";
import { useTutor } from "../../../context/AiTutorContext";
import { questionLayoutStyles } from "./QuestionsLayoutStyles";

export const QuestionsLayout = (props) => {
  const showToast = useCustomToast();
  const { learningStepData, isFactual } = useTutor();
  const [currentQuestion, setCurrentQuestion] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  useEffect(() => {
    // filterDataBasedOnLearningMode(props.learning_mode);
    //filterDataBasedOnLearningMode(learningModes.Interactive);
    //setCurrentQuestion(questionData[currentQuestionIndex]);
    let quesObj = props?.questionObject;
    const questionObjCopy = { ...quesObj };
    let optionLayouts = questionObjCopy?.options_layout?.map((item) => {
      return handleRemoveExtraSpaceInBubbles(item);
    });
    quesObj.modified_options_layout = optionLayouts;

    setCurrentQuestion(quesObj);
  }, []);

  const filterDataBasedOnLearningMode = (learningMode) => {
    switch (String(learningMode)?.toLowerCase()) {
      case learningModes.Interactive:
        setCurrentQuestion(questionData[currentQuestionIndex]);
        break;

      case learningModes.FactualBasket:
        setCurrentQuestion(props.randomPickedQuestions?.[currentQuestionIndex]);
        break;

      case learningModes.ExperienceLearning:
        alert("Please skip experiencial Learning");
        props.handleButtonClick();
        break;

      default:
        setCurrentQuestion(props.learningStepData.questions[0]);
        break;
    }
  };

  const onSend = (item) => {
    props.onAnswerChanged(
      item?.answer,
      currentQuestion,
      item?.hashedIndexAnswer,
      item?.selectedIndex
    );
  };

  const hasNoOptions = currentQuestion?.options_layout?.length == 0;

  return (
    <Box id="question-factual-component">
      <Box id="question-content-container">
        {!isFactual &&
        learningStepData &&
        learningStepData.dialog_entry_script &&
        learningStepData.dialog_entry_script.content &&
        <Assistant
          data-testid="dialog-entry-assistant"
          text={""}
          isCopy={false}
          isDialogScript={true}
          scriptData={learningStepData.dialog_entry_script.content} />

        }
        {isNotEmptyOrNull(currentQuestion?.question_type) &&
        currentQuestion?.question_type !== questionTypes.fib &&
        <Box id="question-display-container" marginBottom={hasNoOptions ? "0px" : "20px"}>
              <Assistant
            data-testid="question-assistant"
            text={
            currentQuestion?.question_layout ?
            currentQuestion?.question_layout :
            ""
            }
            isUser={props?.isUser || false}
            isCopy={props?.allowToCopy || false}
            handleCopyClick={() => {
              handleCopyClick(props?.questionObject?.uuid);
              showToast({
                description: "Question ID copied to clipboard",
                duration: 1000
              });
            }}
            questionType={currentQuestion?.question_type}
            isQuestion={true}
            imagesList={currentQuestion?.images_details}
            hideVin={false} />

            </Box>
        }
        <Box
          id="options-container"
          className={
          currentQuestion?.question_type !== questionTypes.fib ?
          "optionsContainer" :
          "optionsContainerForFIB"
          }
          marginBottom={hasNoOptions ? "0px" : "0px"}>

          <Box id="answer-layout-wrapper" sx={questionLayoutStyles()?.answerLayoutContainer}>
            <AnswersLayout
              data-testid="answers-layout"
              displayedQues={props?.displayedQues}
              userAnswer={props?.userAnswer}
              // userAnswer={
              //   isNotEmptyOrNull(currentQuestion?.answers_key)
              //     ? convertToHashAnswers(props?.userAnswer)
              //     : props?.userAnswer
              // }
              question_type={currentQuestion?.question_type}
              question_id={getQuestionID(currentQuestion)}
              options={currentQuestion?.options_layout}
              modifiedOptions={currentQuestion?.modified_options_layout}
              answers={
              isNotEmptyOrNull(currentQuestion?.answers_index_hashed_keys) ?
              currentQuestion?.answers_index_hashed_keys :
              isNotEmptyOrNull(currentQuestion?.answers_key) ?
              currentQuestion?.answers_key :
              currentQuestion?.answers_layout
              }
              question={currentQuestion?.question}
              option_image_details={currentQuestion?.option_image_details}
              isDisabled={false}
              images_details={currentQuestion?.images_details}
              onSend={onSend}
              onAnswerSubmitted={props?.isAnswerSubmitted}
              isDontAllow={props?.isDontAllow || false}
              allowToCopy={props?.allowToCopy || false}
              currentQuestion={currentQuestion}
              taskType={props.taskType} />

          </Box>
        </Box>
        <Box></Box>
      </Box>
    </Box>);

};